<template>
    <div>
        <b-card class="m-0" no-body>
            <b-card-header
                class="d-flex justify-content-between align-items-center"
            >
                <h5 class="modal-title">
                    {{ isKonfirmasi ? "Konfirmasi" : "" }} Pengeluaran Kas Kecil
                </h5>
            </b-card-header>
            <b-card-body v-show="isKonfirmasi">
                <p>Pengeluaran sebesar Rp. {{ formatNumber(form.nominal) }}.</p>
                <p v-if="form.gudang">
                    Total saldo akan berubah menjadi Rp.
                    {{
                        formatNumberStrict(
                            parseInt(
                                form.gudang
                                    ? form.gudang.saldo_kas_kecil
                                    : gudang.saldo_kas_kecil
                            ) - parseInt(form.nominal)
                        )
                    }}
                </p>
            </b-card-body>
            <b-card-body v-show="!isKonfirmasi">
                <div class="form-group" v-if="!gudang">
                    <label class="form-control-label">Gudang</label>
                    <div class="input-group mb-0 d-flex">
                        <multiselect
                            :class="'w-auto flex-grow-1'"
                            v-validate="'required'"
                            name="gudang"
                            v-model="form.gudang"
                            :options="gudangOptions"
                            :placeholder="'Pilih gudang'"
                            :searchable="true"
                            label="name"
                            track-by="id"
                            :allowEmpty="false"
                            :show-labels="false"
                        ></multiselect>
                        <div class="input-group-append">
                            <button
                                class="btn btn-primary"
                                type="button"
                                @click="selectGudang = true"
                            >
                                <i class="fas fa-search"></i> Pilih
                            </button>
                        </div>
                    </div>
                    <span class="text-danger">{{
                        errors.first("gudang")
                    }}</span>
                </div>

                <div class="form-group">
                    <label class="form-control-label"
                        >Kategori Pengeluaran</label
                    >
                    <div class="input-group mb-0 d-flex">
                        <multiselect
                            :class="'w-auto flex-grow-1'"
                            name="kategori_pengeluaran"
                            v-model="form.kategori_pengeluaran"
                            :options="kategoriOptions"
                            :placeholder="'Pilih kategori pengeluaran'"
                            :searchable="true"
                            label="name"
                            track-by="id"
                            :allowEmpty="true"
                            :show-labels="false"
                        ></multiselect>
                    </div>
                </div>

                <div class="form-group">
                    <label>Nominal</label>
                    <input
                        v-validate="'required|min:0'"
                        min="0"
                        v-model="form.nominal"
                        type="number"
                        name="nominal"
                        class="form-control"
                    />
                    <span class="text-danger">{{
                        errors.first("nominal")
                    }}</span>
                </div>

                <div class="form-group">
                    <label>Keterangan</label>
                    <input
                        v-model="form.notes"
                        type="text"
                        name="notes"
                        class="form-control"
                    />
                    <span class="text-danger">{{ errors.first("notes") }}</span>
                </div>

                <div class="mb-3">
                    <label class="form-control-label">Foto</label>
                    <div class="input-group mb-2">
                        <div class="input-group-prepend">
                            <span
                                class="input-group-text"
                                id="inputGroupFileAddon01"
                                >Upload</span
                            >
                        </div>
                        <div class="custom-file">
                            <input
                                type="file"
                                @change="selectedPhoto"
                                accept="image/png, image/jpeg, image/jpg"
                                class="custom-file-input"
                                id="inputGroupFile01"
                                aria-describedby="inputGroupFileAddon01"
                            />
                            <label
                                class="custom-file-label"
                                for="inputGroupFile01"
                                >{{ photo_label || "Pilih foto" }}</label
                            >
                        </div>
                    </div>
                    <div v-if="photo_url" class="preview-photo">
                        <img :src="photo_url" />
                    </div>
                </div>

                <div class="form-group">
                    <label class="form-control-label">Metode Pembayaran</label>
                    <multiselect
                        class="w-auto flex-grow-1"
                        v-validate="'required'"
                        name="metode_pembayaran"
                        v-model="form.metode_pembayaran"
                        :options="metodeOptions"
                        :placeholder="'Pilih metode pembayaran'"
                        :searchable="true"
                        label="name"
                        track-by="id"
                        :allowEmpty="false"
                        :show-labels="false"
                    ></multiselect>
                    <span class="text-danger">{{
                        errors.first("metode_pembayaran")
                    }}</span>
                </div>
            </b-card-body>
            <b-card-footer class="d-flex flex-row-reverse">
                <template v-if="isKonfirmasi">
                    <button
                        :disabled="isLoading"
                        @click="koreksi"
                        type="button"
                        class="btn btn-secondary"
                    >
                        Koreksi
                    </button>
                    <button
                        :disabled="isLoading"
                        @click="save"
                        type="button"
                        class="btn btn-primary mr-2"
                    >
                        OK
                    </button>
                </template>
                <template v-else>
                    <button
                        :disabled="isLoading"
                        @click="$emit('cancel')"
                        type="button"
                        class="btn btn-secondary"
                        data-dismiss="modal"
                    >
                        Batal
                    </button>
                    <button
                        :disabled="isLoading"
                        @click="konfirmasi"
                        type="button"
                        class="btn btn-primary mr-2"
                    >
                        Simpan
                    </button>
                </template>
            </b-card-footer>
        </b-card>

        <b-modal
            v-model="selectGudang"
            size="lg"
            :hide-header="true"
            :hide-footer="true"
        >
            <gudang-selector
                :selected="gudangOptions"
                @selected="gudangSelected"
                @cancel="selectGudang = false"
            ></gudang-selector>
        </b-modal>
    </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import GudangSelector from "../gudangs/Selector";

export default {
    name: "pengisian-dana-gudang-form",

    props: {
        gudang: {
            type: Object,
            default: () => {},
        },

        value: {
            type: Object,
            default: () => {},
        },
    },

    components: {
        Multiselect,
        GudangSelector,
    },

    data() {
        return {
            form: {
                nominal: null,
                metode: null,
                gudang: null,
                kategori_pengeluaran: null,
                photo: null,
                metode_pembayaran: null,
            },
            selectGudang: false,
            gudangOptions: [],
            kategoriOptions: [],
            isKonfirmasi: false,
            metodeOptions: [
                {
                    name: "tunai",
                    value: "Tunai",
                },
                {
                    name: "transfer",
                    value: "Transfer",
                },
            ],
            photo_label: "",
            photo_url: "",
        };
    },

    created() {
        this.resetForm();
        this.loadKategori();
    },

    mounted() {
        this.resetForm();
    },

    computed: {},

    watch: {},

    methods: {
        resetForm() {
            this.form = Object.assign(
                {},
                {
                    nominal: null,
                    notes: null,
                    gudang: this.gudang ? Object.assign({}, this.gudang) : null,
                    kategori_pengeluaran: null,
                    photo: null,
                    metode_pembayaran: null,
                }
            );

            if (this.value) {
                this.form.nominal = this.value.nominal;
                this.form.notes = this.value.notes;
                this.form.gudang = Object.assign({}, this.value.gudang);
                this.form.kategori_pengeluaran =
                    this.value.kategori_pengeluaran;
                this.photo_url = this.value.photo;
                let metodeIndex = this.metodeOptions.findIndex(
                    (option) => option.name == this.value.metode_pembayaran
                );
                this.form.metode_pembayaran = Object.assign(
                    {},
                    this.metodeOptions[metodeIndex]
                );
            }
        },

        loadKategori() {
            let self = this;

            axios
                .get("/api/kategori-pengeluarans")
                .then(function (response) {
                    self.kategoriOptions = response.data.data;
                })
                .catch(function (error) {
                    self.requestFailed(error);
                });
        },

        konfirmasi() {
            let self = this;

            if (self.value) {
                self.save();
                return;
            }

            self.$validator.validateAll().then((result) => {
                if (result) {
                    self.isKonfirmasi = true;
                }
            });
        },

        koreksi() {
            this.isKonfirmasi = false;
        },

        save() {
            let self = this;

            self.isLoading = true;

            let formData = new FormData();

            formData.append(
                "gudang_id",
                self.form.gudang ? self.form.gudang.id : null
            );
            formData.append(
                "kategori_pengeluaran_id",
                self.form.kategori_pengeluaran
                    ? self.form.kategori_pengeluaran.id
                    : ""
            );
            formData.append("nominal", self.form.nominal);
            formData.append("notes", self.form.notes);
            formData.append("photo", self.form.photo);
            formData.append(
                "metode_pembayaran",
                self.form.metode_pembayaran.name
            );

            let api = self.value
                ? "/api/kas-kecils/" + self.value.id
                : "/api/kas-kecils";

            self.$Progress.start();
            axios({
                method: self.value ? "put" : "post",
                url: api,
                data: formData,
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            })
                .then(function (response) {
                    Toast.fire({
                        icon: "success",
                        title: response.data.message,
                    });
                    self.isLoading = false;
                    self.$Progress.finish();
                    self.$emit("saved", response.data.data);
                })
                .catch(function (error) {
                    self.requestFailed(error);
                });
        },

        gudangSelected(gudang) {
            let self = this;

            self.gudangOptions.push(gudang);
            self.form.gudang = Object.assign({}, gudang);
            self.selectGudang = false;
        },

        selectedPhoto(event) {
            if (!event.target.files.length) {
                return;
            }
            this.form.photo = event.target.files[0];
            this.photo_label = this.form.photo.name;
            this.photo_url = URL.createObjectURL(this.form.photo);
        },
    },
};
</script>
<style>
.preview-photo img {
    max-width: 100%;
    max-height: 200px;
}
</style>
